module.exports = __webpack_public_path__ + "static/img/bg-ar.788f4eb5.png";